export default __webpack_public_path__ + "static/media/278.7f70e6b9.png";